import React, { forwardRef, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Paper, PaperDepth, PaperRadius } from '@cld/paper';
import { focusRing } from '@cld/style-utils';
import { useListStyle } from './ListStyleProvider';

export interface ListProps {
  borderRadius?: PaperRadius;
  depth?: PaperDepth;
}

const PaperWithFocusRing = styled(Paper)`
  ${focusRing()}
`;

/**
 * Pure list component which provides list items container style
 */
export const ListPure = forwardRef<HTMLDivElement, PropsWithChildren<ListProps>>(({ children, borderRadius, depth, ...rest }, ref) => (
  <PaperWithFocusRing role="list" {...rest} borderRadius={borderRadius} depth={depth} ref={ref}>
    {children}
  </PaperWithFocusRing>
));

/**
 * List component that reads variant from context
 */
export const DefaultList = forwardRef<HTMLDivElement, PropsWithChildren<ListProps>>((props, ref) => {
  const listContext = useListStyle();

  return <ListPure {...listContext} {...props} ref={ref} />;
});
